/**
 * Track admin analytics events (e.g. roles & permissions).
 */
import { analyticsTrackEvent } from './analytics';

export const trackAdminEvent = (
  event: string,
  properties?: Record<string, unknown>,
): void => {
  analyticsTrackEvent(event, properties);
};
